import React, { useEffect, useRef, useState } from 'react';
import './LeaveButtonWithDropdown.css';
import { LeaveIcon } from '@livekit/components-react';

interface LeaveButtonWithDropdownProps {
  onLeaveSession: () => void;
  onEndForAll: () => void;
  showIcon?: boolean;
  showText?: boolean;
}

const LeaveButtonWithDropdown: React.FC<LeaveButtonWithDropdownProps> = ({ onLeaveSession, onEndForAll, showIcon, showText }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };

  // Hide dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div ref={dropdownRef} className="leave-btn-dropdown-container">
      <button className="leave-btn" onClick={toggleDropdown}>
        {showIcon && <LeaveIcon />}
        {showText && <span className="leave-span">Leave</span>}
      </button>
      {dropdownOpen && (
        <div className="dropdown-menu">
          <button className="dropdown-item" onClick={onLeaveSession}>Leave</button>
          <button className="dropdown-item" onClick={onEndForAll}>End meeting</button>
        </div>
      )}
    </div>
  );
};

export default LeaveButtonWithDropdown;
